import { isClient } from '@/shared/util/ssr';
import { useEffect, useLayoutEffect } from 'react';

export const useIsomorphicLayoutEffect = isClient ? useLayoutEffect : useEffect;
